module.exports = __webpack_public_path__ + "static/mina-amini-portfolio-57a4c1cc04f7252544ee96f52892e19b.pdf";